import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'brightside-web-spending-account-main',
    templateUrl: './spending-account-main.component.html',
    styleUrls: ['./spending-account-main.component.scss'],
    standalone: false
})
export class SpendingAccountMainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
